import { resolvePublicFeatureFlags } from '@tarifdata/api-client';

export const publicFeatureFlags = resolvePublicFeatureFlags(import.meta.env);
// An explicit literal enables this sensitive surface and lets Vite remove it
// completely from default production builds, including the lazy import.
export const accountingEnabled = import.meta.env.DEV || import.meta.env.VITE_FEATURE_ACCOUNTING === 'true';
